import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Modeling_Session_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_MODELING_SESSION_ID:     {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Modeling Session Id',     columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    MODELING_SESSION_ID:        {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Modeling Session Id',            columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    MODELING_SESSION_NAME:      {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Modeling Session Name',          columnResourceName: 'colModelName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    WB_MODEL_ID:                {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Model ID',                        columnResourceName: 'colModel',          alignment: HorizAlignment.Left},  domainOptions: {}},
    MODEL_NAME:                 {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model',            columnResourceName: 'colModelName',             alignment: HorizAlignment.Left},  domainOptions: {}},
    WB_TREE_FOLDER_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Tree Folder'}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const ModelingSessionSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_MODELING_SESSION_ID',
        id_ui: 'MODELING_SESSION_ID',
        name:  'MODELING_SESSION_NAME'

    },

    searchProviderFields: vUI_Modeling_Session_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Model_Run_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const ModelingSessionSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "ModelingSessionSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'MODELING_SESSION_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'MODELING_SESSION_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'MODELING_SESSION_ID', 'MODELING_SESSION_NAME', 'MODEL_NAME',
        "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelingSessionSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ModelingSessionSearch: ISearch = {
    searchName: "Find Modeling Session",
    renderOptions: {ui5ResourceId: "ModelingSessionSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ModelingSessionSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ModelingSessionBO", "ModelingSession", ModelingSessionSearch, "Modeling Session Search")

export {ModelingSessionSearch}